import React, {
    forwardRef, memo, lazy, useEffect, useState,
} from "react";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, CircularProgress } from "@mui/material";

const importAddIn = (component) => lazy(() => new Promise((resolve) => {
    import("../AddIns/" + component + "/" + component).then((componentPlugin) => { // eslint-disable-line
        resolve(componentPlugin);
    }).catch(() => {
        import("../AddIns/NotFound/NotFound").then((notFound) => {
            resolve(notFound);
        });
    });
}));

const importPluginAddIn = (plugin, component) => lazy(() => new Promise((resolve) => {
    import("../Plugins/" + plugin + "/AddIns/" + component + "/" + component).then((componentPlugin) => { // eslint-disable-line
        resolve(componentPlugin);
    }).catch(() => {
        import("../AddIns/NotFound/NotFound").then((notFound) => {
            resolve(notFound);
        });
    });
}));

function AddIn(props, ref) {
    const {
        plugin, component, isCore, isEditing, setIsDirty, data,
    } = props;

    const [view, setView] = useState(null);

    useEffect(() => {
        (async () => {
            if (isCore) {
                const ImportedAddIn = await importAddIn(component);

                setView(<ImportedAddIn
                    ref={ref}
                    isEditing={isEditing}
                    setIsDirty={setIsDirty}
                    data={data}
                />);
            } else {
                const ImportedAddIn = await importPluginAddIn(
                    plugin[0].toUpperCase() + plugin.slice(1),
                    component,
                );

                setView(<ImportedAddIn
                    ref={ref}
                    isEditing={isEditing}
                    setIsDirty={setIsDirty}
                    data={data}
                />);
            }
        })();
    }, []);

    React.useEffect(() => {
        if (view) {
            setView({ ...view, props });
        }
    }, [props]);

    return (
        <React.Suspense fallback={(
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
            >
                <CircularProgress />
            </Box>
        )}
        >
            {view}
        </React.Suspense>
    );
}

export default memo(forwardRef(AddIn));
